import Image from 'next/image';

import { iconNavigateMapper } from '../mock';

export type SocialIconProps = {
  platform?: string | null;
  src?: string | null;
  width?: number | null;
  height?: number | null;
  alt?: string;
  className?: string;
};

export const hasSocialIcon = (platform?: string | null, src?: string | null) =>
  Boolean(src || (platform && iconNavigateMapper[platform]));

export function SocialIcon({
  platform,
  src,
  width,
  height,
  alt = '',
  className
}: SocialIconProps) {
  if (src) {
    return (
      <Image
        src={src}
        alt={alt}
        width={width || 32}
        height={height || 32}
        className={`max-h-full max-w-full object-contain ${className || ''}`}
      />
    );
  }

  const Icon = platform ? iconNavigateMapper[platform] : undefined;

  return Icon ? <Icon className={`size-8 ${className || ''}`} /> : null;
}
